export const SELECT_ALL_SCENARIO_GROUP_INFO = "SELECT_ALL_SCENARIO_GROUP_INFO";
